module.exports = __webpack_public_path__ + "img/43.9e2fb569.png";